// extracted by mini-css-extract-plugin
module.exports = {"card":"Header_card__cNhJt","buttonGroup":"Header_buttonGroup__3SA1l","favoriteButtonSpacing":"Header_favoriteButtonSpacing__1ny86"};